export default "__VITE_ASSET__DTKpwsb___"